import { Dispatch, SetStateAction, useState } from 'react';
import Switch, { switchClasses } from '@mui/joy/Switch';

interface Props {
    setFormatoMeses: Dispatch<SetStateAction<boolean>>;
    formatoMeses: boolean;
}

export function SwitchInput({ setFormatoMeses, formatoMeses}: Props) {

    return (
        <Switch
            startDecorator={
                <p className="font-semibold">Fecha</p>
            }
            endDecorator={
                <p className="font-semibold">Meses</p>
            }
            color={formatoMeses ? 'success' : 'danger'}
            checked={formatoMeses}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setFormatoMeses(event.target.checked)
            }
            sx={{
                '--Switch-thumbSize': '16px',
                '--Switch-trackWidth': '35px',
                '--Switch-trackHeight': '20px',
                '--Switch-trackBackground': '#EE5E52',
                '&:hover': {
                    '--Switch-trackBackground': '#EE5E52',
                },
                [`&.${switchClasses.checked}`]: {
                    '--Switch-trackBackground': '#5CB176',
                    '&:hover': {
                        '--Switch-trackBackground': '#5CB176',
                    },
                },
            }}
        />
    );
}